import parsePhoneNumberFromString from 'libphonenumber-js/min';

const COUNTRY_MAP = {
  "+1": "US",
  "+54": "AR",
  "+55": "BR",
  "+57": "CO",
  "+33": "FR",
  "+49": "DE",
  "+91": "IN",
  "+62": "ID",
  "+52": "MX",
  "+51": "PE",
  "+63": "PH",
  "+34": "ES",
  "+380": "UA",
  "+44": "GB"
};

export function parseCountryValue(val) {
  if (!val || val.includes("Other")) return { iso: null, code: null, isOther: true };

  const parts = val.split("|");
  const code = parts[1] || null;

  const iso = COUNTRY_MAP[code] || null;

  return {
    iso: iso,
    code: code,
    isOther: false,
  };
}


export function validatePhoneNumber(phone, countryIso, isOther = false) {
  let cleanPhone = (phone || "").trim();
  if (/[^0-9\s\-()+]/.test(cleanPhone)) return { isValid: false };

  const libraryPhone = cleanPhone.replace(/[\s\-()]/g, '');
  if (!libraryPhone || libraryPhone === "+") return { isValid: false };

  try {
    let parsed;
    if (countryIso && !isOther) {
      parsed = parsePhoneNumberFromString(libraryPhone, countryIso);
    } else {
      parsed = parsePhoneNumberFromString(libraryPhone);
    }

    if (!parsed || !parsed.isValid()) {
      return { isValid: false };
    }

    return {
      isValid: true,
      formatted: parsed.number,
      region: parsed.country,
    };
  } catch (e) {
    return { isValid: false };
  }
}

export function initCountryCodeDisplay() {
  $(document).on("change", "[name=country-code]", function () {
    const { code } = parseCountryValue($(this).val() || "");
    const $form = $(this).closest("form");
    let $display = $form.find(".country-code-display");

    if (!$display.length) {
      $display = $('<div class="country-code-display"></div>');
      $(this).closest(".form-field").append($display);
    }
    $display.text(code || "");
  });
}